import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-2xl mb-3" }, "Profit Detail", -1)
const _hoisted_2 = {
  key: 0,
  class: "flex items-center gap-3"
}
const _hoisted_3 = {
  key: 0,
  class: "ml-3"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Fulfillment Warning ")
const _hoisted_5 = { style: {"font-size":"0.75rem"} }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("b", null, "Created:", -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("b", null, "Order date:", -1)
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("b", null, "Approved:", -1)
const _hoisted_11 = {
  key: 2,
  style: {"text-align":"left"}
}
const _hoisted_12 = { class: "font-bold" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("b", null, "Address 1: ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("b", null, "City: ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("b", null, "Province - Zip: ", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("b", null, "Country Code: ", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("b", null, "Phone: ", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("b", null, "Email: ", -1)
const _hoisted_19 = { class: "text-xs" }
const _hoisted_20 = { key: 3 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Comment")
], -1)
const _hoisted_22 = { class: "mt-2" }
const _hoisted_23 = { key: 4 }
const _hoisted_24 = { key: 5 }
const _hoisted_25 = { key: 6 }
const _hoisted_26 = ["title"]
const _hoisted_27 = { key: 7 }
const _hoisted_28 = { key: 8 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Warning = _resolveComponent("Warning")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_InfoFilled = _resolveComponent("InfoFilled")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_CustomDialog = _resolveComponent("CustomDialog")!
  const _component_section_layout_content = _resolveComponent("section-layout-content")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_section_layout_content, _normalizeProps(_guardReactiveProps(_ctx.content)), {
    default: _withCtx(() => [
      _hoisted_1,
      _withDirectives(_createVNode(_component_el_table, {
        data: _ctx.documents,
        "element-loading-text": "Loading...",
        lazy: true,
        style: {"width":"100%"},
        stripe: "",
        "table-layout": "auto"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, index) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              key: index,
              label: column.title,
              "min-width": column.minWidth,
              props: column.dataIndex,
              align: column.align
            }, {
              default: _withCtx((scope) => [
                (column.title === 'Order')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createVNode(_component_el_icon, { size: "20" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Message)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", null, [
                        _createElementVNode("p", null, [
                          _createVNode(_component_router_link, {
                            to: {
                      name: 'seller.orders.detail',
                      params: { id: scope.row.order._id },
                    },
                            class: "text-primary font-bold"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(scope.row.order[column.dataIndex]), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"]),
                          (
                      scope.row?.order.fulfillmentWarning ||
                      scope.row.order.addressValid === 0
                    )
                            ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                                _createVNode(_component_el_popover, {
                                  placement: "top-start",
                                  width: "auto",
                                  trigger: "hover"
                                }, {
                                  reference: _withCtx(() => [
                                    _createVNode(_component_el_icon, { style: {"color":"red"} }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Warning)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_col, { span: 24 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_row, { class: "text-x font-bold" }, {
                                          default: _withCtx(() => [
                                            _hoisted_4
                                          ]),
                                          _: 1
                                        }),
                                        (scope.row?.order.fulfillmentWarning)
                                          ? (_openBlock(), _createBlock(_component_el_row, {
                                              key: 0,
                                              class: "mt-3 font-light"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.getWarningContent(
                                scope.row?.order.fulfillmentWarning
                              )), 1)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : (scope.row.addressValid === 0)
                                            ? (_openBlock(), _createBlock(_component_el_row, {
                                                key: 1,
                                                class: "mt-3 font-light"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("p", null, _toDisplayString(scope.row?.errorMsg || 'Address Invalid!'), 1)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("span", _hoisted_5, [
                          _createElementVNode("p", null, [
                            _hoisted_6,
                            _createTextVNode(" " + _toDisplayString(_ctx.formatTime(scope.row.order.createdDate)), 1)
                          ]),
                          (
                      scope.row?.source === 'API' && scope.row.order.createdAt
                    )
                            ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                                _hoisted_8,
                                _createTextVNode(" " + _toDisplayString(_ctx.formatTime(scope.row.order.createdAt)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (scope.row?.order.approveDate)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                                _hoisted_10,
                                _createTextVNode(" " + _toDisplayString(_ctx.formatTime(scope.row.order.approveDate)), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : (column.dataIndex === 'invoice')
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        to: {
                path: `/s/invoices/${scope.row[column.dataIndex]?._id}`,
              },
                        class: "text-blue-600",
                        title: scope.row[column.dataIndex]?.name
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(scope.row[column.dataIndex]?.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to", "title"]))
                    : (column.dataIndex === 'fullName')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createElementVNode("p", _hoisted_12, [
                            _createTextVNode(_toDisplayString(scope.row.order.fullName) + " ", 1),
                            _createVNode(_component_el_popover, {
                              placement: "top",
                              width: "auto",
                              trigger: "hover"
                            }, {
                              reference: _withCtx(() => [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_InfoFilled)
                                  ]),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, { span: 24 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_row, { class: "text-x font-bold" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(scope.row.order.fullName), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_el_row, { class: "mt-3" }, {
                                      default: _withCtx(() => [
                                        _hoisted_13,
                                        _createTextVNode(" " + _toDisplayString(scope.row.order.address1), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_el_row, { class: "mt-2" }, {
                                      default: _withCtx(() => [
                                        _hoisted_14,
                                        _createTextVNode(" " + _toDisplayString(scope.row.order.city), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_el_row, { class: "mt-2" }, {
                                      default: _withCtx(() => [
                                        _hoisted_15,
                                        _createTextVNode(" " + _toDisplayString(scope.row.order.province) + " - " + _toDisplayString(scope.row.order.zipCode), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_el_row, { class: "mt-2" }, {
                                      default: _withCtx(() => [
                                        _hoisted_16,
                                        _createTextVNode(" " + _toDisplayString(scope.row.order.countryCode), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    (scope.row.phone)
                                      ? (_openBlock(), _createBlock(_component_el_row, {
                                          key: 0,
                                          class: "mt-2"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", null, [
                                              _hoisted_17,
                                              _createTextVNode(" " + _toDisplayString(scope.row.order.phone), 1)
                                            ])
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true),
                                    (scope.row.order.email)
                                      ? (_openBlock(), _createBlock(_component_el_row, {
                                          key: 1,
                                          class: "mt-2"
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_18,
                                            _createTextVNode(" " + _toDisplayString(scope.row.order.email), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _createElementVNode("p", _hoisted_19, _toDisplayString(`(${scope.row.order.countryCode} - ${scope.row.order.province} - ${scope.row.order.zipCode})`), 1)
                        ]))
                      : (column.dataIndex === 'status')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            (scope.row?.order.comment?.length > 0)
                              ? (_openBlock(), _createBlock(_component_el_popover, {
                                  key: 0,
                                  placement: "top",
                                  width: "auto",
                                  trigger: "hover"
                                }, {
                                  reference: _withCtx(() => [
                                    _createVNode(_component_el_tag, {
                                      type: _ctx.getOrderStatusColor(scope.row.status),
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.statusTitleMap.get(scope.row.order.status)), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["type"])
                                  ]),
                                  default: _withCtx(() => [
                                    _hoisted_21,
                                    _createElementVNode("p", _hoisted_22, _toDisplayString(scope.row.order.comment), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : (_openBlock(), _createBlock(_component_el_tag, {
                                  key: 1,
                                  type: _ctx.getOrderStatusColor(scope.row.order.status),
                                  size: "small",
                                  title: _ctx.statusTitleMap.get(scope.row.order.status)
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.statusTitleMap.get(scope.row.order.status)), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["type", "title"]))
                          ]))
                        : (column.dataIndex === 'addressValid')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              _createVNode(_component_el_tag, {
                                type: _ctx.getAddressStatusColor(scope.row.order[column.dataIndex]),
                                effect: "dark",
                                class: "rounded",
                                size: "small",
                                title: _ctx.addressTitleMap.get(scope.row.order[column.dataIndex])
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.addressTitleMap.get(scope.row.order[column.dataIndex])), 1)
                                ]),
                                _: 2
                              }, 1032, ["type", "title"])
                            ]))
                          : (column.dataIndex === 'revenue')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.formatterDollars(scope.row.order.grandTotal)), 1)
                              ]))
                            : (column.dataIndex === 'sellerAmount')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                  _createElementVNode("div", {
                                    title: `Fulfillment cost: ${_ctx.formatterDollars(
                  scope.row.order[column.dataIndex]
                )}`
                                  }, _toDisplayString(_ctx.formatterDollars(scope.row.order[column.dataIndex])), 9, _hoisted_26)
                                ]))
                              : (column.dataIndex === 'total_fees')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.formatterDollars(
                  scope.row.order.paymentFeeValue +
                    scope.row.order.processingFeeValue +
                    scope.row.order.platformFeeValue +
                    scope.row.order.designFeeValue
                )), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.formatterDollars(scope.row.amount)), 1))
              ]),
              _: 2
            }, 1032, ["label", "min-width", "props", "align"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["data"]), [
        [_directive_loading, _ctx.isLoading]
      ]),
      _createVNode(_component_pagination, {
        total: _ctx.total,
        pagination: _ctx.params.page,
        "onUpdate:pagination": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.params.page) = $event)),
        limit: _ctx.params.limit,
        "onUpdate:limit": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.params.limit) = $event))
      }, null, 8, ["total", "pagination", "limit"]),
      _createVNode(_component_CustomDialog, { ref: "customDialog" }, null, 512)
    ]),
    _: 1
  }, 16))
}